/**
 * Default page size for audit logs pagination
 */
export const AUDIT_LOGS_PAGE_SIZE = 20;

/**
 * Limit for fetching previous audit log versions when comparing diffs
 */
export const AUDIT_LOG_DIFF_FETCH_LIMIT = 20;
